import { DesignType } from '@portals/types';

export interface PortalConfigEmailSettingsType {
  logo?: string;
  color?: string;
  created?: boolean;
  primary?: string;
  markdown?: string;
  site_url?: string;
  tertiary?: string;
  secondary?: string;
  custom_from_email?: boolean;
}

export interface PortalConfigType {
  hero: string | null;
  logo: string | null;
  favicon: string | null;
  files: boolean;
  users: boolean;
  design: DesignType;
  signup: boolean;
  reports: boolean;
  support: boolean;
  licenses: boolean;
  incidents: boolean;
  background: string | null;
  sample_data: boolean;
  admin_access: boolean;
  integrations: {
    email: true;
    slack: true;
    msteams: true;
    web_hook: true;
    cisco_teams: true;
  };
  partner_only: boolean;
  control_center: boolean;
  asset_management: boolean;
  digital_products: boolean;
  whitelist_devices: boolean;
  managed_service_providers: boolean;
  domain?: string;
  candidate_domain?: string;
  window_title?: string;
  name?: string;
  email_settings?: Record<string, any>;
}

export enum DomainChangeType {
  OnXyte = 'onXyte',
  Custom = 'custom',
}
